<script>
    import NavbarMenu from '../navbar/navbar_menu.svelte';
    import Navbar from '../navbar/navbar.svelte';
    import Footer from '../landing_page/footer.svelte';
    const {title} = rpcjs.props;
    title.set('About Us');
    
    const slider = [
        {
            image: '/images/aboutpage/TimDraper.png',
            link: 'https://www.linkedin.com/in/timothydraper/',
        },
        {
            image: '/images/aboutpage/AndyTang.png',
            link: '',
        },
        {
            image: '/images/aboutpage/Asra.png',
            link: 'https://www.linkedin.com/in/asranadeem/',
        },
        {
            image: '/images/aboutpage/chris.png',
            link: 'https://www.linkedin.com/in/chrisjjoannou/',
        },
        {
            image: '/images/aboutpage/esau.png',
            link: 'https://www.linkedin.com/in/esaumondragon/',
        },
        {
            image: '/images/aboutpage/subha.png',
            link: 'https://www.linkedin.com/in/subahshahid/',
        },
        {
            image: '/images/aboutpage/khadija.png',
            link: 'https://www.linkedin.com/in/khadijaghazi/',
        },
        {
            image: '/images/aboutpage/mustafa.png',
            link: 'https://www.linkedin.com/in/mohammadmhassan/',
        },
        {
            image: '/images/aboutpage/suffyan.png',
            link: 'https://www.linkedin.com/in/suffiyanmalik/',
        },
        {
            image: '/images/aboutpage/daniel.png',
            link: 'https://www.linkedin.com/in/danielaquinteroc/',
        },
        {
            image: '/images/aboutpage/mahyn.png',
            link: 'https://www.linkedin.com/in/mahyn-qureshi-64952997/',
        },
    ];
    let moving= 'start';
/**
 *
 */
    function moveSlide() {
        if (moving === 'start') {
            moving = 'next-slide';
        } else if (moving === 'next-slide') {
            moving= 'next-three-slide';
        } else if (moving === 'next-three-slide') {
            moving= 'last-three-slide';
        } else {
            moving= 'start';
        }
}
// <!-- Google Tag Manager -->
(function(w, d, s, l, i) {
        w[l]=w[l]||[]; w[l].push({'gtm.start':
        new Date(). getTime(), 'event': 'gtm.js'}); const f=d.getElementsByTagName(s)[0];
        const j=d.createElement(s); const dl=l!='dataLayer'?'&l='+l:''; j.async=true; j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
    // <!-- End Google Tag Manager -->
</script>
<section style="overflow: hidden;">
    <div class="desktop">
        <Navbar colorSent={'white'} />
    </div>
    <div class="mobile">
        <NavbarMenu backgroundColor="transparent" stroke="black" />
    </div>
    
    <div class="desktop">
        <div class="back-img">
            <div>
                <p class="heading">Draper University</p>
            </div>
        </div>
    
        <div class="section" style="display: flex;">
            <div >
                <p class="heading2">MEET<br />THE TEAM</p>
                <div
                    class="next-btn"
                    style="left: 23.5vw;
                    position: absolute;
                    top: 79.1vw;"
                    on:click={() => {
                      moveSlide();
                    }}
                >
                    <img
                        src="/images/aboutpage/arrow.svg"
                        alt=""
                        style="width: 5.489vw; cursor:pointer;"
                    />
                </div>
                <p
                    style="margin-left: 7.343vw; color: rgba(0, 32, 75, 0.8); font-weight: 300; font-size: 1.323vw; width: 17vw;margin-top: 1.5vw;"
                >
                    Working diligently to bring<br />out your success.
                </p>
            </div>
            <div class="slider">
                {#each slider as i}
                    <div class="sli {moving}">
                        <div style=" width: 17.989vw; margin-top: 2.5vw;">
                            <img src={i.image} alt=" " width="100%" />
                        </div>
                        {#if i.link != '' }
                            <a href={i.link} class="linkedin"> linkedin </a>                        
                        {/if}
                    </div>
                {/each}
            </div>
        </div>
    
        <div class="section2">
            <div>
                <p
                    style="font-size: 1.323vw;text-align: center;padding-top: 10.119vw;color: rgba(0, 32, 75, 1); font-weight: 400;text-transform:uppercase;"
                >
                    What makes us different
                </p>
                <p
                    style="font-size: 2.976vw; text-align: center; padding-top: 2.101vw; color: rgb(0, 32, 75); font-weight: 500;text-transform:uppercase;"
                >
                    $240M of Venture Funding
                </p>
                <hr class="horizoltal-line" />
            </div>
            <div style="margin-top: 12.694vw;margin-left:8vw">
                <div style="text-align:center;width:20.5vw;">
                    <div style="width:1.985vw;margin:auto;">
                        <img
                            src="/images/aboutpage/section2_icon1.svg"
                            alt=""
                            width="100%"
                        />
                    </div>
                    <div>
                        <p
                            style="margin-top: 0.861vw;font-weight: 600;color: rgba(0, 32, 75, 1);font-size: 1.190vw;"
                        >
                            3100+ Alumni
                        </p>
                        <p
                            style="font-weight: 300;font-size: 0.926vw;color: rgba(0, 32, 75, 1);    line-height: 1.323vw;
                            padding-top: 0.661vw;"
                        >
                        Our alumni have been featured in Forbes 30 under 30 and are currently funded by some of the most prestigious investors including Marc Benioff, Marc Andreessen, and Tim Draper.
                        </p>
                    </div>
                </div>
            </div>
            <div style="margin-top: 3.340vw;margin-left:14vw">
                <div style="text-align:center;width:19.974vw;">
                    <div style="width:1.985vw;margin:auto;">
                        <img
                            src="/images/aboutpage/section2_icon2.svg"
                            alt=""
                            width="100%"
                        />
                    </div>
                    <div>
                        <p
                            style="margin-top: 0.861vw;font-weight: 600;color: rgba(0, 32, 75, 1);font-size: 1.190vw;"
                        >
                            650+ Companies
                        </p>
                        <p
                            style="font-weight: 300;font-size: 0.926vw;color: rgba(0, 32, 75, 1);    line-height: 1.323vw;
                            padding-top: 0.661vw;"
                        >
                        Our alumni have joined accelerators such as Techstars and YCombinator, have sold their companies for multiple millions.
                        </p>
                    </div>
                </div>
            </div>
            <div style="margin-top: 0.529vw;margin-left:28vw">
                <div style="text-align:center;width:19.974vw;">
                    <div style="width:1.985vw;margin:auto;">
                        <img
                            src="/images/aboutpage/section2_icon3.svg"
                            alt=""
                            width="100%"
                        />
                    </div>
                    <div>
                        <p
                            style="margin-top: 0.861vw; font-weight: 600; color: rgb(0, 32, 75); font-size: 1.19vw;"
                        >
                            8 Unicorns
                        </p>
                        <p
                            style="text-align: center;font-weight: 300;font-size: 0.926vw;color: rgba(0, 32, 75, 1);    line-height: 1.323vw;"
                        >
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                            Et non augue urna id vitae quam sit ut mi.
                        </p>
                    </div>
                </div>
            </div>
            <div
                style="margin-left: 67.923vw; margin-top: -34.978vw;"
            >
                <div>
                    <p
                        style="width: 21.759vw; font-weight: 600; color: rgb(0, 32, 75); font-size: 1.19vw;line-height: 1.653vw;"
                    >
                        DraperU is where brilliant ideas and action converge. We
                        work to inspire founders and accelerate ideas by igniting
                        the entrepreneurial spirit globally.
                    </p>
                    <p
                        style="width: 20.759vw; font-weight: 300; font-size: 0.926vw; color: rgb(0, 32, 75);margin-top: 2vw;"
                    >
                        We offer unique programs including Hero Training,
                        Fundamentals of Entrepreneurship and the GO!
                        Entrepreneurship Immersion Program, aimed to take
                        entrepreneurs out of their comfort zones and push them to
                        deliver their best work.
                    </p>
                </div>
            </div>
            <div>
                <div
                    style=" width: 20.833vw; height: 26.455vw; position: absolute;
                    left: 37.5vw;
                    top: 24.566vw;"
                >
                    <img
                        src="/images/aboutpage/section2_image1.png"
                        alt=""
                        width="100%"
                    />
                </div>
                <div
                    style="height: 14.87vw; width: 11.448vw;position: absolute;
                    left: 50vw;
                    top: 38.235vw;"
                >
                    <img
                        src="/images/aboutpage/Draper University Hero Training Summer 2021-DSC07054 (1) 1.png"
                        alt=""
                        width="100%"
                    />
                </div>
            </div>
        </div>
    
        <div class="section3">
            <div style="position: relative;">
                <div class="circle" />
                <div class="circle" />
                <div class="circle" />
            </div>
            <div style="margin-left: 10.979vw;margin-top: 13.624vw;">
                <p
                    style="height: 3.968vw;font-size: 2.976vw;font-weight: 500;color: rgba(0, 32, 75, 1);"
                >
                    DRAPERU IS A
                </p>
                <p
                    style="width: 34.9vw;font-size: 1.058vw;height: 12.566vw;color: rgba(0, 32, 75, 1);
                    text-align: justify;line-height: 1.280vw;padding-top:0.8vw;"
                >
                    Leading pre-acceleration program in Silicon Valley, is proud to
                    partner with diverse markets, institutions and organizations
                    powered by various governments to fuel the growth of innovation
                    hubs around the world. These exciting partnerships aim to
                    provide emerging innovation ecosystems in LATAM, Europe, Africa
                    and Asia with the complementary Silicon Valley expertise and
                    resources necessary to boost innovation. Since 2017, 75% of
                    Draper University Ventures’ investments have been concentrated
                    in these regions.
                </p>
            </div>
            <div
                style="margin-left: 54.167vw; margin-top: -23.5vw; width: 8.466vw;"
            >
                <div>
                    <img
                        src="/images/aboutpage/diversity.png"
                        alt=""
                        width="100%"
                    />
                </div>
                <div style="margin-top: 2.447vw;">
                    <img
                        src="/images/aboutpage/countries.png"
                        alt=""
                        width="100%"
                    />
                </div>
                <div style="margin-top: 2.447vw;">
                    <img src="/images/aboutpage/avg.png" alt="" width="100%" />
                </div>
            </div>
            <div style="margin-top: 1.85vw;">
                <p
                    style="margin-left: 66.667vw;margin-top: -30.5vw;font-size: 2.976vw;color: rgba(0, 32, 75, 1);    text-transform: uppercase;
                    line-height: 3.968vw;width: 24.735vw;font-weight: 500;"
                >
                    Communities & Environment
                </p>
                <p
                    style="margin-left: 66.667vw; width: 25.3vw; color: rgb(0, 32, 75); font-weight: 300; font-size: 1.058vw;margin-top: 0.8vw;line-height: 1.280vw;
                    text-align: justify;"
                >
                    DraperU has partnered with Tezos, Alogarand and VeChain to offer
                    cutting-edge accelerator programs. Our programming provides the
                    opportunity to gain access to some of the best and brightest
                    startup experts in Silicon Valley. Past speakers include Elon
                    Musk (Tesla), Alex Kehr (Superlocal), and Jenny Guao
                    (Highstreet), among others. Companies founded by DraperU alumni
                    include Lemon Cash, Ledger, SpaceChain and Qtum.
                </p>
                <button on:click={()=>{
                    location.href='/applyProgram';
                }
                    }
                style="font-size:1.19vw;margin-left: 66.667vw; color: white; height: 3.77vw; 
                background-color: rgb(60, 116, 192); width: 15.212vw; margin-top: 1.5vw; border: none; border-radius: 1.984vw;">
                    Join Accelerators
                </button>
            </div>
            <div>
                <div
                    style="margin-left: 18.452vw;width: 26.984vw;margin-top: 14.815vw;"
                >
                    <img
                        src="/images/aboutpage/section3_image1.png"
                        alt=""
                        width="100%"
                    />
                </div>
                <div style="margin-top: -31.81vw;margin-left: 53.638vw;">
                    <p
                        style="width: 31.225vw;font-size: 1.058vw;color: rgba(0, 32, 75, 1);    text-align: justify;
                        line-height: 1.455vw;"
                    >
                        We share a common vision of the future of tech startups with
                        these global organizations to foster growth and innovation.
                        Besides partnering with Draper Ecosystems, these entities
                        have already participated in their regions' efforts to
                        strengthen the growth capitalization strategies for the
                        digital global economy.
                    </p>
                    <p
                        style="width: 31.225vw; font-size: 1.058vw; margin-top: 4.518vw;color: rgba(0, 32, 75, 1);    text-align: justify;
                        line-height: 1.455vw;"
                    >
                        With our high percentage of international startups, Draper
                        University has always worked towards building bridges
                        between these ecosystems and Silicon Valley. We've made
                        multiple visits to LATAM, Europe, Africa and Asia and
                        facilitated numerous startups via participation in our Hero
                        Training Entrepreneurship Program in Silicon Valley. We
                        continue to work closely with organizations in nations such
                        as Turkey, South Korea, Taiwan, Armenia, Senegal, Pakistan,
                        Saudi Arabia, Mexico and Spain to bring talent to Silicon
                        Valley and partner with local institutions to share
                        expertise.
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="mobile">
        <div class="mobile-back-img">
            <div>
                <p class="mobile-heading">DraperU</p>
            </div>
        </div>
    
        <div class="mobile-section" style="display: flex;">
            <div>
                <p class="mobile-heading2">MEET <br /> THE TEAM</p>
                <p
                    style="margin-left: 15vw; color: rgba(0, 32, 75, 0.8); font-weight: 300; font-size: 3.889vw; width: 50.872vw; margin-top: 3.547vw;"
                >
                    Working diligently to bring out your success.
                </p>
                <div
                    style="margin-left: 78.900vw;width: 4.611vw;margin-top: -21vw;"
                >
                    <img
                        src="/images/aboutpage/mobile_arrow.svg"
                        alt=""
                        width="100%"
                    />
                </div>
                <div class="slider-mbl" style="width: 100vw;overflow-x: scroll;">
                    <div style="display:inline-flex;">
                        {#each slider as i}
                            <div style="position: relative;
                            margin-left: 15vw;">
                                <div style=" width: 61.667vw; margin-top: 15vw;">
                                    <img
                                        src={i.image}
                                        alt=" "
                                        style="width: 100%"
                                    />
                                </div>
                                <a href={i.link} class="linkedin_mbl"> linkedin </a>
                            </div>
                        {/each}
                    </div>
                </div>
            </div>
        </div>
        <div class="mobile-section2">
            <div style="position: absolute;">
                <p
                    style="font-size: 4.444vw; text-align: center; padding-top: 40.008vw; color: rgb(0, 32, 75); font-weight: 400;text-transform:uppercase;"
                >
                    What makes us different
                </p>
                <p
                    style="font-size: 8.333vw; text-align: center; padding-top: 2.101vw; color: rgb(0, 32, 75); font-weight: 500;"
                >
                    $240M of Venture Funding
                </p>
                <hr class="mobile-horizoltal-line" />
            </div>
    
            <div>
                <div style="margin-left: 16.388vw;
                width: 55.252vw;
                padding-top: 89.657vw;">
                    <img
                        src="/images/aboutpage/section2_image1.png"
                        alt=""
                        width="100%"
                    />
                </div>
                <div
                    style="margin-left: 45.583vw;
                    height: 14.87vw;
                    width: 33.722vw;
                    margin-top: -32.633vw;"
                >
                    <img
                        src="/images/aboutpage/section2_image2_mbl.png"
                        alt=""
                        width="100%"
                    />
                </div>
            </div>
            <div style="margin-left: 11.667vw; margin-top: 48.444vw;">
                <div>
                    <p
                        style="    width: 67.5vw;
                        font-weight: 600;
                        color: rgb(0, 32, 75);
                        font-size: 5vw;
                        margin-top: -8.625vw;"
                    >
                    DraperU is where brilliant ideas and action converge. We
                    work to inspire founders and accelerate ideas by igniting
                    the entrepreneurial spirit globally.
                    </p>
                    <p
                        style="width: 72.2vw; font-weight: 300; font-size: 4.444vw; color: rgb(0, 32, 75);margin-top: 5.556vw;"
                    >
                    We offer unique programs including Hero Training,
                    Fundamentals of Entrepreneurship and the GO!
                    Entrepreneurship Immersion Program, aimed to take
                    entrepreneurs out of their comfort zones and push them to
                    deliver their best work.
                    </p>
                </div>
            </div>
    
            <div
                style="width: 8.333vw; margin-top: 16.389vw; margin-left: 11.667vw;"
            >
                <img
                    src="/images/aboutpage/section2_icon1.svg"
                    alt=""
                    width="100%"
                />
                <div>
                    <p
                        style="width: 30vw; margin: 3.192vw 0vw; font-weight: 600; color: rgb(0, 32, 75); font-size: 4.444vw;"
                    >
                        3100+ Alumni
                    </p>
                    <p
                        style="margin-bottom: -6vw;
                        width: 79.722vw;
                        font-size: 3.889vw;
                        color: rgb(0, 32, 75);"
                    >
                    Our alumni have been featured in Forbes 30 under 30 and are currently funded by some of the most prestigious investors including Marc Benioff, Marc Andreessen, and Tim Draper.
    
                    </p>
                </div>
            </div>
    
            <div
                style="width: 8.333vw; margin-top: 16.389vw; margin-left: 11.667vw;"
            >
                <img
                    src="/images/aboutpage/section2_icon2.svg"
                    alt=""
                    width="100%"
                />
                <div>
                    <p
                        style="width: 36.667vw; margin: 3.192vw 0vw; font-weight: 600; color: rgb(0, 32, 75); font-size: 4.444vw;"
                    >
                        650+ Companies
                    </p>
                    <p
                        style="margin-bottom: -6vw;
                        width: 79.722vw;
                        font-size: 3.889vw;
                        color: rgb(0, 32, 75);"
                    >
                       Our alumni have joined accelerators such as Techstars and YCombinator, have sold their companies for multiple millions.
                    </p>
                </div>
            </div>
    
            <div
                style="width: 8.333vw; margin-top: 16.389vw; margin-left: 11.667vw;"
            >
                <img
                    src="/images/aboutpage/section2_icon3.svg"
                    alt=""
                    width="100%"
                />
                <div>
                    <p
                        style="width: 36.667vw; margin: 3.192vw 0vw; font-weight: 600; color: rgb(0, 32, 75); font-size: 4.444vw;"
                    >
                        8 Unicorns
                    </p>
                    <p
                        style="width: 79.722vw; font-size: 3.889vw; color: rgb(0, 32, 75); "
                    >
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Et non augue urna id vitae quam sit ut mi.
                    </p>
                </div>
            </div>
        </div>
    
        <div class="mobile-section3">
            <div style="position: relative;">
                <div class="mobile-circle" />
                <div class="mobile-circle" />
                <div class="mobile-circle" />
            </div>
            <div style="margin-left: 7.5vw; padding-top: 9.5vw;">
                <p
                    style="height: 7.222vw; font-size: 8.333vw; font-weight: 600; color: rgb(0, 32, 75);"
                >
                    DraperU is a
                </p>
            </div>
            <div style="margin-left: 10.833vw; margin-top: 7.778vw;">
                <p
                    style="width: 81.111vw; font-size: 3.889vw; height: 12.566vw; color: rgb(0, 32, 75);"
                >
                    Leading pre-acceleration program in Silicon Valley, is proud to
                    partner with diverse markets, institutions and organizations
                    powered by various governments to fuel the growth of innovation
                    hubs around the world. These exciting partnerships aim to
                    provide emerging innovation ecosystems in LATAM, Europe, Africa
                    and Asia with the complementary Silicon Valley expertise and
                    resources necessary to boost innovation. Since 2017, 75% of
                    Draper University Ventures’ investments have been concentrated
                    in these regions. <br /><br />
    
                    We share a common vision of the future of tech startups with
                    these global organizations to foster growth and innovation.
                    Besides partnering with Draper Ecosystems, these entities have
                    already participated in their regions' efforts to strengthen the
                    growth capitalization strategies for the digital global economy.
                    <br /> <br />
    
                    With our high percentage of international startups, Draper
                    University has always worked towards building bridges between
                    these ecosystems and Silicon Valley. We've made multiple visits
                    to LATAM, Europe, Africa and Asia and facilitated numerous
                    startups via participation in our Hero Training Entrepreneurship
                    Program in Silicon Valley. We continue to work closely with
                    organizations in nations such as Turkey, South Korea, Taiwan,
                    Armenia, Senegal, Pakistan, Saudi Arabia, Mexico and Spain to
                    bring talent to Silicon Valley and partner with local
                    institutions to share expertise.
                </p>
            </div>
            <div
                style="margin-left: 5.833vw; margin-top: 228.889vw; width: 19.408vw;">
                    <img
                        src="/images/aboutpage/diversity.png"
                        alt=""
                        width="100%"
                    />
                    <img
                        src="/images/aboutpage/countries.png"
                        alt=""
                        width="100%"
                        style="margin-top: 5.610vw;"
                    />
                    <img src="/images/aboutpage/avg.png" alt="" width="100%" style="margin-top:5.610vw;"/>
            </div>
            <div>
                <p
                    style="margin-left: 33.333vw;
                    margin-top: -77vw;
                    font-size: 5.556vw;
                    color: rgb(0, 32, 75);
                    width: 70.556vw;
                    font-weight: 600;"
                >
                    Communities & Environment
                </p>
                <p
                    style="margin-left: 33.333vw;
                    width: 52.222vw;
                    color: rgb(0, 32, 75);
                    font-weight: 300;
                    font-size: 3.056vw;
                    line-height: 3.512vw;
                    margin-top: 4.5vw;"
                >
                DraperU has partnered with Tezos, Alogarand and VeChain to offer cutting-edge accelerator programs. 
                Our programming provides the opportunity to gain access to some of the best and brightest startup experts in Silicon Valley. 
                Past speakers include Elon Musk (Tesla), Alex Kehr (Superlocal), and Jenny Guao (Highstreet), among others. Companies founded by DraperU alumni 
                include Lemon Cash, Ledger, SpaceChain and Qtum.
    
                </p>
                <button
                    on:click={() => (location.href = '/applyProgram')}
                    style="font-size: 3.056vw;
                    margin-left: 33.333vw;
                    color: white;
                    height: 8.642vw;
                    background-color: rgb(60, 116, 192);
                    width: 34.875vw;
                    margin-top: 7.477vw;
                    border: none;
                    border-radius: 4.55vw;"
                    >Join Accelerators</button
                >
            </div>
        </div>
    </div>
    
    <Footer />
</section>


<style>
    p{
        padding: 0;
        margin: 0;
    }
    .sli{
        position: relative;
        margin-left: 3vw;
        transition: transform 1s, opacity 2s;
    }
    .start{
        transform: translate(0vw);
        opacity: 1;
    }
    .next-slide{
        transform: translate(-63vw);
        opacity: 1;
    }
    .next-three-slide{
        transform: translate(-122vw);
        opacity: 1;
    }
    .last-three-slide{
        transform: translate(-164.6vw);
        opacity: 1;
    }
    .slider::-webkit-scrollbar {
        display: none;
    }
    .slider-mbl::-webkit-scrollbar {
        display: none;
    }
    .slider {
        display: flex;
        width: 70vw;
        height: 31.82vw;
        scroll-behavior: smooth;
        overflow: hidden;
        margin-left: 6.5vw;
    }
    .back-img {
        height: 49.272vw;
        background-image: url("images/aboutpage/DraperUniversityHeroTrainingSummer.png");
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;
    }
    .heading {
        width: 39.22vw;
        margin-left: 30.357vw;
        padding-top: 37.573vw;
        font-weight: 600;
        color: white;
        font-size: 4.63vw;
    }
    .heading2 {
        margin-left: 7.332vw;
        padding-top: 14.69vw;
        font-weight: 500;
        color: rgba(0, 32, 75, 1);
        font-size: 2.976vw;
        line-height: 3.968vw;
    }
    .section {
        margin-top: 9vw;
    }
    .section2 {
        height: 71.526vw;
        background-color: rgb(220 229 237);
        margin-top: -2vw;
        position: relative;
        /* z-index: -1; */
    }
    .section3 {
        height: 82.526vw;
        background-color: rgb(255, 255, 255);
    }
    .linkedin {
        font-size: 1.058vw;
        color: #3c74c0;
        position: absolute;
        top: 3vw;
        left: 13vw;
        text-decoration: none;
    }
    .linkedin_mbl {
        font-size: 3.889vw;
        color: #3c74c0;
        position: absolute;
        top: 17vw;
        left: 43vw;
        text-decoration: none;
    }
    .horizoltal-line {
        width: 33.929vw;
        margin-top: -0.1vw;
        margin-left: 33.003vw;
        height: 0.15vw;
        /* border: 0.198vw solid rgba(0, 32, 75, 1); */
    }
    .circle {
        height: 24.818vw;
        width: 24.818vw;
        border-radius: 50%;
        opacity: 40%;
        position: absolute;
        left: -20vw;
        top: -13vw;
        background-color: rgba(60, 136, 195, 0.33);
    }

    .circle:nth-child(2) {
        top: -1vw;
    }
    .circle:nth-child(3) {
        top: 9.5vw;
    }
    .slider-mobile::-webkit-scrollbar {
        display: none;
    }
    .mobile-section {
        margin-top: 20vw;
    }
    .mobile-back-img {
        height: 177.778vw;
        background-image: url("/images/aboutpage/Mobile-Draper-University.png");
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;
    }
    .mobile-heading {
        width: 33.611vw;
        padding-left: 33.056vw;
        padding-top: 127.222vw;
        font-weight: 600;
        color: white;
        font-size: 8.333vw;
    }
    .mobile-heading2 {
        padding-left: 15.011vw;
        font-weight: 500;
        background: linear-gradient(1.05deg, #00204b 20.19%, #00429b 85.35%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-size: 8.333vw;
    }
    .mobile-section2 {
        height: 468.388vw;
        background-color: rgb(220 229 237);
        margin-top: -4vw;
        position: relative;
    }
    .mobile-section3 {
        height: 358.526vw;
        background-color: rgb(255, 255, 255);
        margin-top: -2vw;
    }
    .mobile-horizoltal-line {
        width: 83.333vw;
        margin-left: 8.333vw;
        border: 0.198vw solid rgba(0, 32, 75, 1);
    }
    .mobile-circle {
        height: 43.611vw;
        width: 29.611vw;
        border-radius: 50%;
        opacity: 40%;
        position: absolute;
        left: -20vw;
        background-color: rgba(60, 136, 195, 0.33);
        margin-top: 33.889vw;
    }
    .mobile-circle:nth-child(2) {
        top: 23vw;
    }
    .mobile-circle:nth-child(3) {
        top: 45vw;
    }
    .desktop {
        display: block;
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
    }
</style>
